/* eslint eqeqeq: "off" */

export default {
  company: (state) => state.company,
  paymentMethods: (state) => state.paymentMethods,
  getPaymentMethod: (state) => (id) =>
    state.paymentMethods.find((paymentMethod) => paymentMethod.id == id),
};
